import * as yup from "yup";

export const createOrganisationSchema = yup.object().shape({
    name: yup.string().required('Organisation Name is required'),
    type: yup.string().required('Organisation Type is required'),
    parentOrganization: yup.string(),
    termsAndConditions: yup.boolean().oneOf([true], 'Please accept Terms and Conditions.'),
    grps: yup.boolean().oneOf([true], 'Please accept gdpr policy.')
}).required();